import {registerJQueryComponent} from '@lib/JQueryRegistry'

export default class RoundedToggleButton {

    /**
     * Constructs a new {@link RoundedToggleButton}.
     * @param {HTMLElement} rootElement
     */
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            circle: rootElement.find('.circle')
        }

        this.$state = {
            active: false
        }

        this.$dom.root.click(this.onClicked)
    }

    onClicked = e => {
        this.$state.active = !this.$state.active

        if (this.$state.active) {
            this.$dom.root.removeClass('inactive').addClass('active')
        } else {
            this.$dom.root.removeClass('active').addClass('inactive')
        }
    }
}

registerJQueryComponent(RoundedToggleButton, '.rounded-toggle-button')